import React from 'react'
import Home from '../views/Home'
import Imprint from '../views/Imprint'
import Privacy from '../views/Privacy'
import { Switch, Route } from 'react-router-dom';

export default function Main(){
    return(
        <main>
             <Switch> {/* The Switch decides which component to show based on the current URL.*/}
                <Route exact path='/' component={Home}></Route>
                <Route exact path='/imprint' component={Imprint}></Route>
                <Route exact path='/privacy' component={Privacy}></Route>
            </Switch>
        </main>
    )
}